/**
 * @generated SignedSource<<93d3400119dd0eae1245e0e0528f2bc9>>
 * @relayHash 62b90c8c9202e7e6dbd60ac66c43d566
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dc6487520fea330dc5426ec56152c12e802dbe513fdce848a33f5a37dce6ca98

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_jiraBusinessBoardQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type src_jiraBusinessBoardQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly " $fragmentSpreads": FragmentRefs<"ProjectContextProvider">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment">;
};
export type src_jiraBusinessBoardQuery = {
  response: src_jiraBusinessBoardQuery$data;
  variables: src_jiraBusinessBoardQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v5 = [
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "src_jiraBusinessBoardQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "ProjectContextProvider"
              }
            ]
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "src_workManagementBoard_BoardViewRootWithSmartCard_queryFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "src_jiraBusinessBoardQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "large"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "projectStyle"
              },
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              {
                "alias": "assignIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "ASSIGN_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"ASSIGN_ISSUES\")"
              },
              {
                "alias": "administerProject",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              },
              {
                "alias": "createIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "CREATE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"CREATE_ISSUES\")"
              },
              {
                "alias": "deleteIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "DELETE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"DELETE_ISSUES\")"
              },
              {
                "alias": "editIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"EDIT_ISSUES\")"
              },
              {
                "alias": "linkIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "LINK_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"LINK_ISSUES\")"
              },
              {
                "alias": "scheduleIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "SCHEDULE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
              },
              {
                "alias": "transitionIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "TRANSITION_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"TRANSITION_ISSUES\")"
              },
              {
                "alias": "viewIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v4/*: any*/),
                "storageKey": "action(type:\"VIEW_ISSUES\")"
              }
            ]
          },
          {
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "mediaClientId"
          },
          {
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "mediaExternalEndpointUrl"
          },
          {
            "alias": "rankField",
            "args": [
              {
                "fields": [
                  {
                    "kind": "Literal",
                    "name": "aliasFieldIds",
                    "value": [
                      "rank"
                    ]
                  },
                  (v1/*: any*/)
                ],
                "kind": "ObjectValue",
                "name": "filter"
              }
            ],
            "concreteType": "JiraFieldConfigConnection",
            "kind": "LinkedField",
            "name": "jiraFieldConfigs",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFieldConfigEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldConfig",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v5/*: any*/),
            "concreteType": "JiraIssueLinkTypeConnection",
            "kind": "LinkedField",
            "name": "issueLinkTypes",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "totalCount"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "dc6487520fea330dc5426ec56152c12e802dbe513fdce848a33f5a37dce6ca98",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cc38a202d0a3a4e6b7716889d9524274";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
